import React from 'react';

interface IValidation {
  message: string;
  hasError: boolean;
}

interface IProps {
  validation: IValidation;
}

export default class ValidationFeedback extends React.Component<IProps, {}> {
  renderFeedback(result: boolean, message: string, faIcon?: string): JSX.Element {
    return (
      <small className={`warning text-${result ? 'danger' : 'success'} pull-right`}>
        {message} <i className={`fa fa-${faIcon}`} aria-hidden="true" />
      </small>
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.renderFeedback(
          this.props.validation.hasError,
          this.props.validation.message,
          this.props.validation.hasError ? 'asterisk' : 'check'
        )}
      </React.Fragment>
    );
  }
}
